import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const PERL = () => {

    const faqSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is covered in the PERL Scripting training course at Takshila VLSI?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The PERL Scripting course covers basic syntax, arrays, hashes, file operations, regular expressions, OOP concepts, process management, and regression automation through practical exercises."
      }
    },
    {
      "@type": "Question",
      "name": "Who is eligible to join the PERL Scripting training course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Candidates with B.E./B.Tech in ECE, EEE, EIE, CSE, or IT, MCA, M.Sc., M.E., M.Tech, or M.S. in relevant computer science, electronics, or embedded systems streams can apply."
      }
    },
    {
      "@type": "Question",
      "name": "What is the duration of the PERL Scripting training course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The PERL Scripting training course at Takshila VLSI lasts four weeks and combines theory sessions, hands-on lab practice, and industry-oriented projects to develop practical scripting skills."
      }
    },
    {
      "@type": "Question",
      "name": "How is PERL Scripting used in ASIC Verification?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "PERL Scripting helps ASIC Verification engineers automate regression runs, process log files, handle test data, search patterns, and simplify repetitive tasks across verification workflows."
      }
    },
    {
      "@type": "Question",
      "name": "Does Takshila VLSI provide placement assistance after PERL Scripting training?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Takshila VLSI provides 100% placement assistance, job-oriented training, soft skills development, and industry-focused project experience to help learners prepare for relevant career opportunities."
      }
    },
    {
      "@type": "Question",
      "name": "Is hands-on lab practice included in the PERL Scripting course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, the course includes practical lab sessions, industry-standard projects, course materials, and 24×7 lab support to help learners apply PERL concepts to scripting and automation tasks."
      }
    },
    {
      "@type": "Question",
      "name": "Can beginners learn PERL Scripting for VLSI careers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, eligible engineering and postgraduate candidates can learn PERL fundamentals, file handling, regular expressions, and regression automation to build scripting skills relevant to VLSI workflows."
      }
    },
    {
      "@type": "Question",
      "name": "Who teaches the PERL Scripting training course at Takshila VLSI?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The course is guided by Mr. Rajiv, an ASIC Verification Specialist with over 13 years of experience in design verification, protocols, ASIC and FPGA flows, and PERL scripting."
      }
    },
    {
      "@type": "Question",
      "name": "Is the PERL Scripting training available online and offline?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Takshila VLSI offers online and offline training options, allowing learners to access course materials, practical sessions, and industry-focused learning based on their preferred learning mode."
      }
    }
  ]
};

const courseSchema={
  "@context": "https://schema.org",
  "@type": "Course",
  "@id": "https://www.takshila-vlsi.com/perl-scripting/#course",
  "name": "PERL Scripting Training",
  "description": "PERL Scripting Training at Takshila VLSI develops practical scripting skills for engineers working in design verification and related technical fields. The four-week course covers PERL syntax, data types, arrays, hashes, file operations, regular expressions, pattern matching, object-oriented programming, process management, log file processing and regression automation through hands-on learning and industry-oriented projects.",
  "url": "https://www.takshila-vlsi.com/perl-scripting/",
  "provider": {
    "@type": "Organization",
    "@id": "https://www.takshila-vlsi.com/#organization",
    "name": "Takshila VLSI",
    "url": "https://www.takshila-vlsi.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
    },
    "email": "info@takshila-vlsi.com",
    "telephone": "+91-9742972744"
  },
  "coursePrerequisites": [
    "B.E./B.Tech in ECE, EEE, EIE, CSE or IT",
    "MCA or M.Sc. in Computer Science or Electronics",
    "M.E./M.Tech/M.S. in Computer Science, Embedded Systems or Electronics"
  ],
  "timeRequired": "P4W",
  "hasCourseInstance": {
    "@type": "CourseInstance",
    "courseMode": [
      "Online",
      "Onsite"
    ],
    "courseWorkload": "P4W",
    "instructor": {
      "@type": "Person",
      "name": "Mr. Rajiv",
      "jobTitle": "ASIC Verification Specialist",
      "description": "Design Verification specialist with over 13 years of experience in IP, sub-system and SoC-level verification, ASIC and FPGA design flows, and protocols including PCIe, USB, SATA and DDR."
    }
  },
  "about": [
    "PERL Scripting",
    "PERL Programming",
    "Regular Expressions",
    "File Handling",
    "Log File Processing",
    "Design Verification",
    "Regression Automation",
    "Object-Oriented Programming",
    "Data Processing"
  ],
  "teaches": [
    "PERL Introduction and Basic Syntax",
    "Comments, Whitespace, Quotes and Escape Sequences",
    "PERL Data Types and Scalars",
    "Arrays, Array Slicing and Splice Functions",
    "Split and Join Functions",
    "Sorting and Merging Arrays",
    "Hashes and Complex Data Structures",
    "Chomp, Chop, Map and Grep Functions",
    "Variable Scopes",
    "Strict and Warnings",
    "Conditional Statements and Loops",
    "Operators and Subroutines",
    "References and Nested Data Structures",
    "Formats and File I/O Operations",
    "Directory Operations and Error Handling",
    "Packages and Modules",
    "Regular Expressions and Pattern Matching",
    "Sending Email and Special Variables",
    "Method Calls and DBI Access",
    "Object-Oriented Programming and Object Creation",
    "Eval Function and Inheritance",
    "Installing CPAN Modules",
    "Process Management",
    "Regression Automation"
  ]
};

  return (
    <div>
    <Helmet>
    <title>Perl Scripting Training Course for VLSI Engineers | Takshila VLSI</title>
	<meta name="description" content="Join Perl Scripting training to automate VLSI design and verification workflows through practical, industry-focused sessions with Takshila VLSI." />
	<link rel="canonical" href="https://www.takshila-vlsi.com/perl-scripting/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Perl Scripting Training Course for VLSI Engineers | Takshila VLSI" />
	<meta property="og:description" content="Join Perl Scripting training to automate VLSI design and verification workflows through practical, industry-focused sessions with Takshila VLSI." />
	<meta property="og:url" content="https://www.takshila-vlsi.com/perl-scripting/" />
	<meta property="og:site_name" content="Takshila VLSI" />
	<meta property="article:modified_time" content="2021-03-09T13:59:49+00:00" />
	<meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/12/PERL-Traning-1024x678.jpg" />
	<meta property="og:image:width" content="1024" />
	<meta property="og:image:height" content="678" />
	<meta property="og:image:type" content="image/jpeg" />
	<meta name="twitter:card" content="summary_large_image" />

    <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
                </script>
                <script type="application/ld+json">
                {JSON.stringify(courseSchema)}
                </script>

     </Helmet>
    <Header/>
<main>
    <section class="section-banner pg-banner ws-section pt-5 bg-14">
    <div class="container text-center">
                <div class="row justify-content-around p-lg-5 pb-0">
                    <div class="col-md-9">
                        <div class="pg-title-sec">
                            <h1 className='pg-title pb-3'>PERL 
                            <span className='bg-txt mx-3'>Scripting</span>
                            </h1>
                            <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                        </div>
                    </div>
                    <div class="col-md-12 align-self-center mb-3">
                            <a href="/register-now">
                                <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                    </div>
                </div>
                <div class="row justify-content-center img-radius g-3">
                    <div class="col-md-2 align-self-end d-none d-sm-block">
                    <img src={img1} alt=''/>
                    </div>
                    <div class="col-md-2 align-self-end">
                    <div className='course-bnr-bx bg-8 radius-1'>
                            <h4 className='course-bnr-title'>100%</h4>
                            <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                        </div>
                    </div>
                    <div class="col-md-3 align-self-end">
                    <img src={img2} alt=''/>
                    </div>
                    <div class="col-md-2 align-self-end">
                    <div className='course-bnr-bx bg-7 radius-1'>
                            <h4 className='course-bnr-title'>100%</h4>
                            <p className='course-bnr-desc'>Learners became better at their job</p>
                        </div>
                    
                    </div>
                    <div class="col-md-2 align-self-end d-none d-sm-block">
                    <img src={img3} alt=''/>
                    </div>
                </div>
    </div>
</section>
<section className='course-desc p-lg-5 bg-14'>
        <div class="container text-center">
                <div class="row justify-content-around text-center">
                    <div class="col-md p-5">
                            <h2 className='ws-section_heading pd-03'><span className='font-thin'>PERL Scripting Training / PERL Training
                            </span> Courses in Bangalore/ Hyderabad</h2>
                    </div>
                </div>
                <div class="row justify-content-around">
                    <div class="col-md">
                            <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                            <div className='text-left text-xl'>
                            <p>The perl course trains the engineers extensively on the scripting skills used in different fields. This skill is an add-on to the industry skills such as Design Verification Methodologies and help them to join the industry with scripting skills.</p>
                            <p>The key features of the Perl Scripting involves file operations, grepping, pattern match, basic oop, regular expressions and regression run, which are widely used for sampling the logfiles, and test runs in the industry. The scripts make the life of any verification engineer, or designer easy, while working with different files and tons of data processing. The course is designed to have learning by doing, to have goo hold over the concepts.</p>
                            </div>
                    </div>
                </div>
        </div>
</section>
<section className='highlight-section p-lg-5 p-2 bg-14'>
    <div class="container bg-9 p-lg-5 p-3 radius-1">
        <div className='mb-5'>
        <div className='txt-2 mb-2'>Eligibility</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>B.E/B.Tech in ECE/EEE/EIE/CSE/IT
                </div>
            </div>
            </div>
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>MCA/M.Sc (computers/Electronics).
                </div>
            </div>
            </div>
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>M.E/M.Tech/M.S in Computer Science streams/Embedded Systems/Electronics streams.
                </div>
            </div>
            </div>
        </div>
        </div>
        <div className='mb-5'>
        <div className='txt-2 mb-2'>Course Duration</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>4 Weeks</div>
            </div>
            </div>
        
        </div>
        </div>
        <div>
        <div className='txt-2 mb-2'>Course Highlights</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Covers the PERL regular expression widely used in industry.</div>
            </div>
        
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Regression flow automation.</div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>24×7 Lab Support with Lab practice handouts and course material delivery.</div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Industry standard project execution, Lab practice and theory sessions under the guidance of industry expert with 12+ years of experience.
                </div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Soft skills development, complete suite of job oriented ASIC Verification training with 100% placement assistance.</div>
            </div>
            
            </div>
        </div>
        </div>
            
    </div>
</section>

<section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/rajiv/'><h4>Mr. Rajiv</h4></a>
              <h6 className='pb-3'>(ASIC Verification Specialist)</h6>
              <p>Mr. Rajiv comes with a 13+ years of rich experience in Design Verification in IP, Sub-System and SoC levels. Working experience in multiple protocol-lgs like PCIe, USB, SATA, DDR, Ethernet etc, and also he has working experience in both ASIC and FPGA design flows. We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.
              </p>
              
              <div class="wpb_wrapper"><p>We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.</p>
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Skills:</strong><br/>
                        Verilog, VHDL,<br/>
                        System Verilog<br/>
                        UVM, OVM, VMM<br/>
                        PERL
                        </p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Protocol-lgs Worked On:</strong><br/>
                        PCIe, USB, SATA, DDR, Ethernet<br/>
                        AMBA Protocol-lgs</p>
                  
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Tools:</strong><br/>
                        ModelSim, VCS, IRUN<br/>
                        Quartus II (Altera FPGA Development Platform)</p>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

<section className='curriculum-section pt-5'>
    <div className='container'>
        <div class="row justify-content-center mb-5">
        <div class="col-lg-8 text-center">
        <h3 class="ws-section_heading pb-03 txt-3">PERL Scripting Training Institute in Bangalore
        </h3>
        </div>
        </div>
        <div class="row mb-5">
            <div class="col-lg-8">
            <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
            </div>
            <div class="col-lg-4 align-self-center">
            <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
            
            </div>
        </div>
        <div className='row'>
            <div className='col-lg'>
            <div className='curriculum-accord accordion'>
                    <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Module 1: PERL (Practical Extracting Report Language)</Accordion.Header>
                        <Accordion.Body>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Introduction </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Basic Syntax</div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Commenting </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Whitespace_Quotes_Escapesequences </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Data types  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Scalars </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Arrays </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Arrays_Slicing___Splice_Function </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Split & Join </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Sort_Array,_$_and_Merging </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Chomp and Chop </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Map and Grep  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Types of Variable Scopes  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Strict and Warnings  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Decision Conditioning </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Loops </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Operator </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Subroutines  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>References </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Array of array </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of arrays  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Arrays of hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of complex records </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Formats </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>File IO Operations  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Directories </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Error handling  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Packages and modules  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Regular expressions </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Sending email </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Special variables </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Calling method </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>DBI access </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Creating objects in OOP </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Eval Function </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Inheritance </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Installing CPAN module </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Process management  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Regression  </div>
                        </div>
                    </Accordion.Body>
                    </Accordion.Item>
                    
                    

                    </Accordion>
                    </div>
            </div>
        </div>

    </div>
            </section>

            <Companysec/>
<Whysec/>           
<Offersec/>


<section className='ws-section pb-5 bg-white'>
    <div class="container text-center">
    <div className='row pb-3'>
            <div className='col-lg text-center'>
            <h2 class="ws-section_heading">Connect With Us</h2>
        </div>
        </div>
    <div class="row justify-content-around">
                    <div class="col-lg-5">
                        <div className='trainer-box'>
                            <div className='content-box wd-80 d-flex bg-path'>
                            <div className='trainer-content'>
                            <h5 className='trainer-title text-left'>Join us & achieve <br/>
                            your goals.</h5>
                            </div>
                            </div>
                            <div className='trainer-img img-radius mb-3'>
                            <img src={img4} alt=''/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        
                        <iframe
                            aria-label='Register Now'
                            width="100%"
                            height="850"
                            src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                            frameborder="0" 
                        
                        />
                    
                    </div>
                </div>
    </div>
</section>

 <section className='course-faq-section ws-section p-lg-5 bg-14'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg text-center'>
                <h2 class="ws-section_heading">Frequently Asked Questions</h2>
            </div>
            </div>
            <div className='row justify-content-center pb-5'>
                <div className='col-lg-10'>
                <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>1. What is covered in the PERL Scripting training course at Takshila VLSI?</Accordion.Header>
                            <Accordion.Body><p>The PERL Scripting course covers basic syntax, arrays, hashes, file operations, regular expressions, OOP concepts, process management, and regression automation through practical exercises.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>2. Who is eligible to join the PERL Scripting training course?</Accordion.Header>
                            <Accordion.Body><p>Candidates with B.E./B.Tech in ECE, EEE, EIE, CSE, or IT, MCA, M.Sc., M.E., M.Tech, or M.S. in relevant computer science, electronics, or embedded systems streams can apply.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>3. What is the duration of the PERL Scripting training course?</Accordion.Header>
                            <Accordion.Body>
                            <p>The PERL Scripting training course at Takshila VLSI lasts four weeks and combines theory sessions, hands-on lab practice, and industry-oriented projects to develop practical scripting skills.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header>4. How is PERL Scripting used in ASIC Verification?</Accordion.Header>
                            <Accordion.Body>
                            <p>PERL Scripting helps ASIC Verification engineers automate regression runs, process log files, handle test data, search patterns, and simplify repetitive tasks across verification workflows.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header>5. Does Takshila VLSI provide placement assistance after PERL Scripting training?</Accordion.Header>
                            <Accordion.Body>
                            <p>Yes, Takshila VLSI provides 100% placement assistance, job-oriented training, soft skills development, and industry-focused project experience to help learners prepare for relevant career opportunities.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                            <Accordion.Header>6. Is hands-on lab practice included in the PERL Scripting course?</Accordion.Header>
                            <Accordion.Body>
                            <p>Yes, the course includes practical lab sessions, industry-standard projects, course materials, and 24×7 lab support to help learners apply PERL concepts to scripting and automation tasks.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header>7. Can beginners learn PERL Scripting for VLSI careers?</Accordion.Header>
                            <Accordion.Body>
                            <p>Yes, eligible engineering and postgraduate candidates can learn PERL fundamentals, file handling, regular expressions, and regression automation to build scripting skills relevant to VLSI workflows.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="7">
                            <Accordion.Header>8. Who teaches the PERL Scripting training course at Takshila VLSI?</Accordion.Header>
                            <Accordion.Body>
<p>The course is guided by Mr. Rajiv, an ASIC Verification Specialist with over 13 years of experience in design verification, protocols, ASIC and FPGA flows, and PERL scripting.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="8">
                            <Accordion.Header>9. Is the PERL Scripting training available online and offline?</Accordion.Header>
                            <Accordion.Body>
Takshila VLSI offers online and offline training options, allowing learners to access course materials, practical sessions, and industry-focused learning based on their preferred learning mode.
                            </Accordion.Body>
                        </Accordion.Item>
                        
                        </Accordion>
                </div>
            </div>
            <div class="row justify-content-center mt-5">
                    <div class="col-lg-9">
                        <div class="callaction-2">
                            <div class="row g-3">
                            <div class="col-lg-7">
                                <h2>Don't see your questions ? answered here?</h2>
                            </div>
                            <div class="col-lg-4 align-self-center text-center">
                            <a href="/contact-us/">
                            <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                            </div>
                            </div> 
                        </div>
                    </div>
                </div>
        </div>
    </section>


<Videoreview/>
<Enrollaction/>
<Partnersec/> 
</main>
<Footer/>
</div>
  )
}

export default PERL